import CreateOrder from "@/views/admin/order/CreateOrder";

export default {
  path: "orders/create-order",
  name: "CreateOrder",
  component: CreateOrder,
  meta: {
    requiresAuth: true
  }
};
